import Lenis from 'lenis'

// Премиум ультра-плавный скролл с Lenis
class PremiumSmoothScroll {
  constructor() {
    this.lenis = null
    this.init()
  }

  init() {
    // Проверка на reduced motion (доступность)
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    
    if (prefersReducedMotion) {
      console.log('Smooth scroll disabled: user prefers reduced motion')
      return
    }

    // Инициализация Lenis с премиум настройками
    this.lenis = new Lenis({
      duration: 1.2,        // Длительность плавности (1-1.5 для премиум эффекта)
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Кастомный easing
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,     // Плавное колесо мыши
      wheelMultiplier: 1.0,  // Скорость колеса
      smoothTouch: false,    // Отключаем на мобилках (нативный лучше)
      touchMultiplier: 2,
      infinite: false,
      autoResize: true,      // Авто-пересчет при изменении размера
    })

    // Обновление каждый кадр для 120-144Hz мониторов
    const raf = (time) => {
      this.lenis.raf(time)
      requestAnimationFrame(raf)
    }
    requestAnimationFrame(raf)

    // Остановка при переходах React Router
    window.addEventListener('popstate', () => {
      this.lenis.scrollTo(0, { immediate: true })
    })

    // Синхронизация с программным скроллом
    window.lenis = this.lenis

    console.log('✨ Premium smooth scroll активирован (Lenis)')
  }

  // Метод для программной прокрутки
  scrollTo(target, options = {}) {
    if (this.lenis) {
      this.lenis.scrollTo(target, options)
    } else {
      // Fallback для reduced motion
      const element = typeof target === 'string' ? document.querySelector(target) : target
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', ...options })
      } else if (typeof target === 'number') {
        window.scrollTo({ top: target, behavior: 'smooth' })
      }
    }
  }

  // Уничтожение при размонтировании
  destroy() {
    if (this.lenis) {
      this.lenis.destroy()
      this.lenis = null
    }
  }
}

// Инициализация после загрузки DOM
if (typeof window !== 'undefined') {
  let smoothScroll = null
  
  window.addEventListener('DOMContentLoaded', () => {
    smoothScroll = new PremiumSmoothScroll()
    window.smoothScroll = smoothScroll
  })

  // Cleanup при размонтировании (для hot reload)
  if (module.hot) {
    module.hot.dispose(() => {
      if (smoothScroll) {
        smoothScroll.destroy()
      }
    })
  }
}

export default PremiumSmoothScroll
